import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Typography,
  Box,
  Grid
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';

// Lägg till props-typ
interface SimpleContactFormProps {
  onSuccess?: () => void;
}

const SimpleContactForm: React.FC<SimpleContactFormProps> = ({ onSuccess }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);

    // 🔔 Anropa onSuccess om det finns
    if (onSuccess) {
      onSuccess();
    }
  };

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => {
        navigate('/');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [submitted, navigate]);

  if (submitted) {
    return (
      <Box textAlign="center" mt={6}>
        <CheckCircleIcon sx={{ color: 'green', fontSize: 40, mb: 2 }} />
        <Typography variant="h6" color="green">
          {t('contactform.confirmationMessage')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="form"
      action="https://formspree.io/f/xeogggqj"
      method="POST"
      onSubmit={handleSubmit}
      sx={{ maxWidth: 800, margin: 'auto', p: 2 }}
    >
      <Typography variant="h5" gutterBottom sx={{ color: '#c6a04c' }}>
        {t('other.title')}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField name="contactName" label={t('contactform.contactName')} fullWidth required />
        </Grid>

        <Grid item xs={12}>
          <TextField name="contactEmail" label={t('contactform.contactEmail')} type="email" fullWidth required />
        </Grid>

        <Grid item xs={12}>
          <TextField
            name="message"
            label={t('contactform.message')}
            fullWidth
            multiline
            rows={4}
            required
          />
        </Grid>

        {/* Skicka med sidinformation */}
        <input type="hidden" name="page" value="Kontakta oss – övriga frågor" />

        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: '#c6a04c',
              color: '#000',
              '&:hover': { backgroundColor: '#d1ae5a' }
            }}
          >
            {t('contactform.submit')}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SimpleContactForm;
